import { TransferAccountType } from "../class/transferIntent";

export const isEmployerSponsored = (planType: TransferAccountType): boolean => {
  return (
    planType === TransferAccountType.EMPLOYER_401k ||
    planType === TransferAccountType.EMPLOYER_403b ||
    planType === TransferAccountType.EMPLOYER_457
  );
};
